export default class Injury
{
    constructor(personal_info, injury_info, housing_info, lands, cash_allowance, construction_grant){
        this.personal_info      = personal_info
        this.injury_info        = injury_info
        this.housing_info       = housing_info
        this.lands              = lands
        this.cash_allowance     = cash_allowance
        this.construction_grant = construction_grant
    }

    toFormData(){
        let fData = new FormData()
        
        //personal information for injury.
        fData.append('name1', this.personal_info.name1);
        fData.append('name2', this.personal_info.name2);
        fData.append('name3', this.personal_info.name3);
        fData.append('name4', this.personal_info.name4);
        fData.append('family_name', this.personal_info.family_name);
        fData.append('mother_name', this.personal_info.mother_name);
        fData.append('birth_date', this.personal_info.birth_date);
        fData.append('phone1', this.personal_info.phone1);
        fData.append('phone2', this.personal_info.phone2);    
        fData.append('marital_status_id', this.personal_info.marital_status_id);
        fData.append('certificate_id', this.personal_info.certificate_id);
        fData.append('number_children', this.personal_info.number_children);
        fData.append('religion_id', this.personal_info.religion_id);
        fData.append('nationalism_id', this.personal_info.nationalism_id);
        if(this.personal_info.id_type == '1'){
            fData.append('nationality_number', this.personal_info.nationality_number);
        }else{
            fData.append('national_id_number', this.personal_info.national_id_number);
        }
        
        //injury info.
        fData.append('date_wound', this.injury_info.date_wound);
        fData.append('place_wound', this.injury_info.place_wound);
        fData.append('dept', this.injury_info.dept);
        fData.append('place_wound_in_body', this.injury_info.place_wound_in_body);
        fData.append('disability_ratio', this.injury_info.disability_ratio);

        //attachment info.
        fData.append('attachment_basic', this.personal_info.attachment_personal);
        if(typeof this.injury_info.attachment_info == 'object')
            fData.append('attachment_info', this.injury_info.attachment_info);

        //housing info.
        fData.append('accommodation_id', this.housing_info.accommodation_id);
        fData.append('city_id', this.housing_info.city_id);
        fData.append('region', this.housing_info.region);
        fData.append('nearest_point', this.housing_info.nearest_point);
        fData.append('mahla', this.housing_info.mahla);
        fData.append('zqaq', this.housing_info.zqaq);
        fData.append('dar', this.housing_info.dar);

        // lands.
        this.lands.fields.forEach((el, i)=>{
            fData.append('earthSections['+i+'][grant_name]', el.grant_name);
            fData.append('earthSections['+i+'][section_number]', el.section_number);
            fData.append('earthSections['+i+'][accommodation_id]', el.accommodation_id);
            fData.append('earthSections['+i+'][area_section]', el.area_section);
            fData.append('earthSections['+i+'][city_id]', el.city_id);
            fData.append('earthSections['+i+'][district]', el.district);
            fData.append('earthSections['+i+'][sub_district]', el.sub_district);
            fData.append('earthSections['+i+'][attachment]', el.attachment_lands);
        });

        // cash allowance.
        this.cash_allowance.fields.forEach((el, i)=>{
            fData.append('moneysReplace['+i+'][grant_name]', el.grant_name);
            fData.append('moneysReplace['+i+'][received_date]', el.received_date);
            fData.append('moneysReplace['+i+'][ammont]', el.ammont);
            fData.append('moneysReplace['+i+'][attachment]', el.attachment_cash);
        });

        // construction grant.
        this.construction_grant.fields.forEach((el, i)=>{
            fData.append('buildsReplace['+i+'][grant_name]', el.grant_name);
            fData.append('buildsReplace['+i+'][section_number]', el.section_number);
            fData.append('buildsReplace['+i+'][accommodation_id]', el.accommodation_id);
            fData.append('buildsReplace['+i+'][area_section]', el.area_section);
            fData.append('buildsReplace['+i+'][city_id]', el.city_id);
            fData.append('buildsReplace['+i+'][district]', el.district);
            fData.append('buildsReplace['+i+'][sub_district]', el.sub_district);
            fData.append('buildsReplace['+i+'][grant_name]', el.grant_name);
            fData.append('buildsReplace['+i+'][received_date]', el.received_date);
            fData.append('buildsReplace['+i+'][ammont]', el.ammont);
            fData.append('buildsReplace['+i+'][attachment]', el.attachment_grant);
        });

        return fData
    }
}

